import request from 'utils/request'

// 获取行业分类
function getMajorIfy(data){
  return request({
    url:'/api/trades',
    method:'get',
    params:data,
  })
}
// 获取专业分类
function getIndustryIfy(data){
  return request({
    url:'/api/majors',
    method:'get',
    params:data,
  })
}

// 获取问题分类
function getQuesIfy(data){
  return request({
    url:'/api/problems',
    method:'get',
    params:data,
  })
}

// 获取问题分类
function lawyerlist(data){
  return request({
    url:'/api/lawyerlist',
    method:'get',
    params:data,
  })
}

export default  {
  getMajorIfy,
  getIndustryIfy,
  getQuesIfy,
  lawyerlist
	
}